import { cn } from "../../lib/utils";

// Shimmers rather than pulses: see .skeleton-shimmer in index.css.
function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("skeleton-shimmer rounded-md", className)}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
